import React from "react";
import { Tag } from "antd";
import moment from "moment";

const DaysOfWeek = (props) => {
  const { text } = props;
  return (
    <div>
      {text &&
        text.map((item, i) => (
          <Tag style={{ margin: "2px" }} key={i}>
            {moment.weekdays(true)[item]}
          </Tag>
        ))}
    </div>
  );
};

export default DaysOfWeek;
